import React, { useEffect } from 'react';
import { Table, Pagination, Dimmer, Loader, Segment } from 'semantic-ui-react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  getAllBusiness,
  setActiveBusinessDetails,
  openBusinessDetails,
  closeBusinessDetails,
  setBusinessMenuItem,
} from 'state/business/actions';
import BusinessDetails from './BusinessDetails';

const ListBusiness = props => {
  const {
    dispatch,
    allBusiness,
    filters,
    gettingAllBusiness,
    businessDetails,
  } = props;
  let allBusinessData = null;
  let paging = null;
  if (allBusiness) {
    allBusinessData = allBusiness.data;
    paging = allBusiness.paging;
  }
  let totalPages = 1;
  if (paging) totalPages = Math.ceil(paging.total / paging.size);

  useEffect(() => {
    const payload = {
      page: 1,
      size: 10,
    };
    dispatch(getAllBusiness(payload));
    dispatch(closeBusinessDetails());
    dispatch(setBusinessMenuItem('business'));
  }, [dispatch]);

  const handleOnPageChange = (_, val) => {
    const {
      startDate,
      endDate,
      status,
      searchKeyword,
      invoiceNumber,
      searchBy,
    } = filters;
    const { activePage } = val;
    const payload = {
      page: activePage,
      size: 10,
      startDate,
      endDate,
      status,
      searchKeyword,
      invoiceNumber,
      searchBy,
    };
    dispatch(getAllBusiness(payload));
  };

  const handleBusinessOnClick = index => {
    dispatch(setActiveBusinessDetails({ index, businessData: allBusiness }));
    dispatch(openBusinessDetails());
  };

  const dateTimeFormat = new Intl.DateTimeFormat('id', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return (
    <div>
      {!businessDetails || allBusiness.activeIndex === -1 ? (
        <Segment style={{ padding: '0px' }}>
          <Dimmer active={gettingAllBusiness}>
            <Loader size="massive">Loading</Loader>
          </Dimmer>
          <Table
            size="small"
            selectable
            singleline
            fixed
            style={{ margin: '0px' }}
          >
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Business Name</Table.HeaderCell>
                {!businessDetails ? (
                  <>
                    <Table.HeaderCell>Email</Table.HeaderCell>
                    <Table.HeaderCell>#Outlets</Table.HeaderCell>
                    <Table.HeaderCell>Expiration</Table.HeaderCell>
                    <Table.HeaderCell>Billing Cycle</Table.HeaderCell>
                    <Table.HeaderCell>Name</Table.HeaderCell>
                    <Table.HeaderCell>Last Login</Table.HeaderCell>
                  </>
                ) : (
                  <></>
                )}
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {allBusinessData ? (
                allBusinessData.map((business, index) => {
                  let keys = '';
                  Object.keys(business).forEach(key => {
                    keys += business[key];
                  });
                  return (
                    <Table.Row
                      key={keys}
                      onClick={() => handleBusinessOnClick(index)}
                      style={{ cursor: 'pointer' }}
                    >
                      <Table.Cell
                        key={`${keys}name`}
                        active={
                          allBusiness.activeIndex === index && businessDetails
                        }
                      >
                        {business.name}
                      </Table.Cell>
                      {!businessDetails ? (
                        <>
                          <Table.Cell key={`${keys}owner_email`}>
                            {business.owner_email}
                          </Table.Cell>
                          <Table.Cell key={`${keys}outlet_count`}>
                            {business.outlets_count}
                          </Table.Cell>
                          <Table.Cell key={`${keys}expired_at`}>
                            {(() => {
                              if (!business.expired_at) return null;
                              const date = new Date(business.expired_at);
                              return dateTimeFormat.format(date);
                            })()}
                          </Table.Cell>
                          <Table.Cell key={`${keys}billing_cycle`}>
                            {business.billing_cycle}
                          </Table.Cell>
                          <Table.Cell key={`${keys}owner_name`}>
                            {business.owner_name}
                          </Table.Cell>
                          <Table.Cell key={`${keys}last_sign_in_at`}>
                            {(() => {
                              if (!business.last_sign_in_at) return null;
                              const date = new Date(business.last_sign_in_at);
                              return dateTimeFormat.format(date);
                            })()}
                          </Table.Cell>
                        </>
                      ) : (
                        <></>
                      )}
                    </Table.Row>
                  );
                })
              ) : (
                <></>
              )}
            </Table.Body>
            {paging && !businessDetails ? (
              <Table.Footer>
                <Table.Row>
                  <Table.HeaderCell colSpan="7">
                    <Pagination
                      activePage={paging.page}
                      totalPages={totalPages}
                      onPageChange={handleOnPageChange}
                      size="mini"
                    />
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Footer>
            ) : (
              <></>
            )}
          </Table>
        </Segment>
      ) : (
        <Segment style={{ padding: '0px' }}>
          <BusinessDetails />
        </Segment>
      )}
    </div>
  );
};

const mapStateToProps = ({ business }) => ({
  allBusiness: business.allBusiness,
  gettingAllBusiness: business.gettingAllBusiness,
  filters: business.filters,
  businessDetails: business.businessDetails,
});

ListBusiness.propTypes = {
  dispatch: PropTypes.func.isRequired,
  allBusiness: PropTypes.object.isRequired,
  gettingAllBusiness: PropTypes.bool.isRequired,
  filters: PropTypes.object.isRequired,
  businessDetails: PropTypes.bool.isRequired,
};
export default connect(mapStateToProps)(ListBusiness);
